const axios = require('axios');
const { AVAILABLE_METRICS } = require('../utils/datadog/metrics');

const createMetricSender = () => {
  const serviceUrl = '/promotions-section/api/metrics';
  function sendEventForCustomerMetric(event) {
    axios
      .post(serviceUrl, {
        event,
      })
      .catch((e) => console.error('Error sending metric', e));
  }

  return {
    onRestaurantsSectionClicked: () =>
      sendEventForCustomerMetric(AVAILABLE_METRICS.SECTION_RESTAURANT_CLICK),
    onGroceriesSectionClicked: () =>
      sendEventForCustomerMetric(AVAILABLE_METRICS.SECTION_GROCERIES_CLICK),
    onPaymentMethodsSectionClicked: () =>
      sendEventForCustomerMetric(
        AVAILABLE_METRICS.SECTION_PAYMENT_METHODS_CLICK,
      ),
    onLoadedEmptyState: () =>
      sendEventForCustomerMetric(AVAILABLE_METRICS.LOADED_EMPTY_STATE),
    sendServerError: () =>
      sendEventForCustomerMetric(AVAILABLE_METRICS.SERVER_ERROR),
    sendClientError: () =>
      sendEventForCustomerMetric(AVAILABLE_METRICS.CLIENT_ERROR),
    onVendorRestaurantClicked: () =>
      sendEventForCustomerMetric(AVAILABLE_METRICS.VENDOR_RESTAURANT_CLICK),
    onDishRestaurantClicked: () =>
      sendEventForCustomerMetric(AVAILABLE_METRICS.DISH_RESTAURANT_CLICK),
    onBannerRestaurantClicked: () =>
      sendEventForCustomerMetric(AVAILABLE_METRICS.BANNER_RESTAURANT_CLICK),
    onShopGroceriesClicked: () =>
      sendEventForCustomerMetric(AVAILABLE_METRICS.SHOP_GROCERIES_CLICK),
    onProductGroceriesClicked: () =>
      sendEventForCustomerMetric(AVAILABLE_METRICS.PRODUCT_GROCERIES_CLICK),
    onBannerGroceriesClicked: () =>
      sendEventForCustomerMetric(AVAILABLE_METRICS.BANNER_GROCERIES_CLICK),
    onBinPaymentClicked: () =>
      sendEventForCustomerMetric(AVAILABLE_METRICS.BIN_PAYMENT_CLICK),
    onLoadedRestaurants: () =>
      sendEventForCustomerMetric(AVAILABLE_METRICS.LOADED_RESTAURANTS),
    onLoadedGroceries: () =>
      sendEventForCustomerMetric(AVAILABLE_METRICS.LOADED_GROCERIES),
    onLoadedPaymentMethods: () =>
      sendEventForCustomerMetric(AVAILABLE_METRICS.LOADED_PAYMENT_METHODS),
  };
};

module.exports = { createMetricSender };
